/**
 * @generated SignedSource<<0ba16d1281ae7577d2b7e32df67cbdbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EnableModuleInput = {
  companyId: string;
  moduleType?: string | null;
  startYear?: number | null;
  startMonth?: number | null;
  startDay?: number | null;
  endYear?: number | null;
  endMonth?: number | null;
  endDay?: number | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type enableModuleMutation$variables = {
  input: EnableModuleInput;
};
export type enableModuleMutation$data = {
  readonly enableModule: {
    readonly module: {
      readonly node: {
        readonly id: string;
        readonly companyId: string;
        readonly moduleType: string | null;
        readonly enabledByTier: boolean | null;
        readonly startYear: number | null;
        readonly startMonth: number | null;
        readonly startDay: number | null;
        readonly endYear: number | null;
        readonly endMonth: number | null;
        readonly endDay: number | null;
      } | null;
    } | null;
  } | null;
};
export type enableModuleMutation = {
  variables: enableModuleMutation$variables;
  response: enableModuleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EnableModulePayload",
    "kind": "LinkedField",
    "name": "enableModule",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ModuleEdge",
        "kind": "LinkedField",
        "name": "module",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Module",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "companyId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "moduleType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "enabledByTier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDay",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endYear",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endMonth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDay",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "enableModuleMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "enableModuleMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2dd2bf587cc4a32d9eefe30e9fadd302",
    "id": null,
    "metadata": {},
    "name": "enableModuleMutation",
    "operationKind": "mutation",
    "text": "mutation enableModuleMutation(\n  $input: EnableModuleInput!\n) {\n  enableModule(input: $input) {\n    module {\n      node {\n        id\n        companyId\n        moduleType\n        enabledByTier\n        startYear\n        startMonth\n        startDay\n        endYear\n        endMonth\n        endDay\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "76b0970712dc53dc920a3ba106dde0a6";

export default node;
